import React, { useMemo, useState } from 'react';

import { Box, Button, Header, Link, Modal, SpaceBetween } from '@amzn/awsui-components-react-v3';

import { useMetrics } from 'appSelectorContext';

import { METRIC_PUBLISHER_NAMES } from '../../constants';
import { Model } from '../../store/types';
import { MPN_WARNING_CANCELED } from './constants';

interface ModelNotInASNConfirmationProps {
  model?: Model;
  onDismiss: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  displayScosReceiptsLink?: boolean;
}

export const ModelNotInASNConfirmation = ({
  onDismiss,
  onConfirm,
  children,
  model,
  displayScosReceiptsLink = false,
}: ModelNotInASNConfirmationProps) => {
  const [visible, setVisible] = useState(true);
  const context = useMetrics();
  const publisher = context.initialMetricsPublisher.newChildActionPublisherForMethod(METRIC_PUBLISHER_NAMES.SCAN_MPN);
  const appendText = useMemo(() => {
    if (displayScosReceiptsLink) {
      return (
        <Box variant="span" margin={{ left: 'xs' }}>
          <Box variant="span">Ensure Qty is financially received in </Box>
          <Link href="https://aws.argo.ocean-wave.aws.a2z.com/ordering/requests/receipt/" target="_blank">
            SC.os receipt
          </Link>
        </Box>
      );
    }
    return null;
  }, [displayScosReceiptsLink]);

  return (
    <Modal
      onDismiss={() => {
        publisher.publishCounterMonitor(MPN_WARNING_CANCELED, 1);
        setVisible(false);
        onDismiss && onDismiss();
      }}
      visible={visible}
      size="large"
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" ariaLabel="cancel missing model" onClick={onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" ariaLabel="confirm missing model" onClick={onConfirm}>
              Continue
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={
        <Header variant="h2" actions={null} description={appendText}>
          {`Model ${model?.expectedMPN} not expected in shipment.`}
        </Header>
      }
    >
      {children}
    </Modal>
  );
};
